import React, { useState } from 'react';
import { Input, Button, Form, Card, message } from 'antd';
import axios from '../axios'; // Ensure you have axios installed

const LoginPage = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false); // For loading state of the button

    const handleLogin = async () => {
        if (username && password) {
            setLoading(true);
            try {
                // Make API request
                const response = await axios.post('/api/v1/auth', { username, password });
                const { code, msg, data } = response.data;

                if (code === 0) {
                    // Successfully logged in
                    localStorage.setItem('token', data.token); // Save token in localStorage
                    localStorage.setItem('expires_at', data.expires_at); // Save expiration time
                    onLogin(); // Trigger login callback passed as prop
                    message.success('登录成功');
                } else {
                    // Handle different error codes
                    switch (code) {
                        case 1001:
                            message.error('用户名或密码错误');
                            break;
                        case 1002:
                            message.error('账户已被锁定');
                            break;
                        default:
                            message.error(msg || '登录失败');
                            break;
                    }
                }
            } catch (error) {
                message.error(error);
            } finally {
                setLoading(false); // Stop loading after API call
            }
        } else {
            message.error('请输入用户名和密码');
        }
    };

    return (
        <Card title="登录" style={{ width: 300, margin: 'auto', marginTop: 100 }}>
            <Form>
                <Form.Item label="用户名">
                    <Input
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="请输入用户名"
                    />
                </Form.Item>
                <Form.Item label="密码">
                    <Input.Password
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="请输入密码"
                    />
                </Form.Item>
                <Form.Item>
                    <Button
                        type="primary"
                        block
                        onClick={handleLogin}
                        loading={loading} // Show loading spinner when the button is clicked
                    >
                        登录
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default LoginPage;
